(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-layout-switcher"] && !Shopify.designMode) return;
  try {
    // Layout switcher uses a simple state machine so each viewport remembers its own column choice.
  // State: current viewport (mobile or desktop, from a width breakpoint) and one stored column
  // count per viewport (e.g. 1 col on mobile, 4 on desktop). When the user resizes across the
  // breakpoint, we switch viewport and re-apply that viewport’s stored preference, so e.g.
  // “1 column on mobile” is restored when going back to mobile after changing desktop to 4 columns.
  // Elements are resolved on each use (not cached) so the switcher keeps working after the
  // filter module replaces the layout and switcher in the DOM.
  // Selection per viewport is persisted in sessionStorage so it survives filter changes and page reloads until the browser/tab is closed.
  const BREAKPOINT = 480;
  const STORAGE_KEY = 'collection-layout-cols';

  function getElements() {
    return {
      layoutElement: document.querySelector('.js-layout-switcher-layout'),
      layoutSwitcher: document.querySelector('.collection-layout-switcher'),
    };
  }

  function loadStoredPrefs() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const p = JSON.parse(raw);
      const mobile = Math.min(4, Math.max(1, parseInt(p.mobile, 10) || 1));
      const desktop = Math.min(4, Math.max(1, parseInt(p.desktop, 10) || 4));
      return { mobile, desktop };
    } catch {
      return null;
    }
  }

  function savePrefs() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        mobile: state.mobile.cols,
        desktop: state.desktop.cols,
      }));
    } catch (_) {}
  }

  // State machine: viewport + one stored preference per viewport (restored when crossing breakpoint).
  // Initial values from sessionStorage if present, else DOM defaults; state survives DOM replace.
  const stored = loadStoredPrefs();
  const state = {
    viewport: null, // 'mobile' | 'desktop'
    mobile: { cols: stored ? stored.mobile : 1 },
    desktop: { cols: stored ? stored.desktop : 4 },
  };

  function applyView() {
    const { layoutElement, layoutSwitcher } = getElements();
    if (!layoutElement || !layoutSwitcher) return;

    const toggleButtons = Array.from(layoutSwitcher.querySelectorAll('button'));
    const getButton = (cols) =>
      toggleButtons.find((el) => parseInt(el.getAttribute('data-toggle-grid'), 10) === cols);

    // Set viewport when not yet set (e.g. first run after filter replaced DOM before onResize).
    // Prefer stored prefs; fall back to DOM defaults only when nothing was ever saved.
    if (state.viewport === null) {
      state.viewport = window.innerWidth < BREAKPOINT ? 'mobile' : 'desktop';
      const storedNow = loadStoredPrefs();
      if (storedNow) {
        state.mobile.cols = storedNow.mobile;
        state.desktop.cols = storedNow.desktop;
      } else {
        state.mobile.cols = parseInt(layoutSwitcher.getAttribute('data-products-per-row-mobile'), 10) || 1;
        state.desktop.cols = parseInt(layoutSwitcher.getAttribute('data-products-per-row-desktop'), 10) || 4;
      }
    }

    const view = state.viewport === 'mobile' ? state.mobile : state.desktop;
    const cols = view.cols;
    const button =
      getButton(cols) || (state.viewport === 'mobile' ? toggleButtons[0] : toggleButtons[toggleButtons.length - 1]);

    Array.from(layoutElement.classList).forEach((c) => {
      if (c.startsWith('grid-cols-')) layoutElement.classList.remove(c);
    });
    layoutElement.classList.add(`grid-cols-${cols}`);

    toggleButtons.forEach((b) => b.classList.remove('is-active'));
    if (button) button.classList.add('is-active');
  }

  function setViewport(viewport) {
    if (state.viewport === viewport) return;
    state.viewport = viewport;
    applyView();
  }

  function setColumns(cols) {
    const view = state.viewport === 'mobile' ? state.mobile : state.desktop;
    view.cols = cols;
    savePrefs();
    applyView();
  }

  function onResize() {
    if (state.viewport === null) {
      const storedNow = loadStoredPrefs();
      if (storedNow) {
        state.mobile.cols = storedNow.mobile;
        state.desktop.cols = storedNow.desktop;
      } else {
        const { layoutSwitcher } = getElements();
        if (layoutSwitcher) {
          state.mobile.cols = parseInt(layoutSwitcher.getAttribute('data-products-per-row-mobile'), 10) || 1;
          state.desktop.cols = parseInt(layoutSwitcher.getAttribute('data-products-per-row-desktop'), 10) || 4;
        }
      }
    }
    const viewport = window.innerWidth < BREAKPOINT ? 'mobile' : 'desktop';
    setViewport(viewport);
  }

  onResize();

  // Event delegation: works after the filter module replaces the switcher in the DOM
  document.addEventListener('click', (e) => {
    const button = e.target.closest('.collection-layout-switcher button');
    if (!button) return;
    const cols = parseInt(button.getAttribute('data-toggle-grid'), 10);
    if (!Number.isNaN(cols)) setColumns(cols);
  });

  window.addEventListener('resize', onResize);

  // Re-apply when the filter/sort module finishes replacing the section (global.bundle.js dispatches this)
  document.addEventListener('shapes:section:hasmutated', () => requestAnimationFrame(applyView));
  } catch(e) { console.error(e); }
})();

})();
